import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=3d7895c3&scoped=true&"
import script from "./RiskManagement.vue?vue&type=script&lang=ts&"
export * from "./RiskManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=3d7895c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7895c3",
  null
  
)

export default component.exports